export const fromTheCollectionQuery = `
  query getRandomArtwork($filter: String) {
    artworks(first: 5, where: { metaValue: $filter }) {
      nodes {
        artists {
          nodes {
            name
          }
        }
        dates
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        imageSrcset
        slug
        title
      }
    }
  }
`;
